module.exports = __webpack_public_path__ + "static/media/training.a0178c63.jpg";